import { Component, OnInit, OnDestroy, NgZone, Inject, PLATFORM_ID, Input } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

// service
import { LoginService } from '../../services/login.service';
import { SharedService } from '../../services/shared-service.service';
import { CopyService } from '../../../shared/services/app-copy.service';

// models
import { AppState } from '../../../booking/models/app-state.interface';
import { FormsModule } from '@angular/forms';
import { OverviewComponent } from 'app/booking/components/overview/overview.component';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';

declare var zE: any;

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, FormsModule, OverviewComponent, LanguageSelectorComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  @Input() componentRender:string = '';

  private _routeSubscription: Subscription;
  private _bookingInitSubscription: Subscription;
  private _bookingStateSubscription: Subscription;
  private _flyBackStateSubscription: Subscription;
  private _userSubscription: Subscription;
  private _challengeShopperSubscription: Subscription;
  private _userLanguageSubscription: Subscription;

  private _initLoad = true;

  public currentPartner = null;
  public brandingPartner = null;
  public user;
  public price;
  public currentRoute = '';
  public showOverview = false;
  public bookingInit: Boolean = false;
  public priceInit: Boolean = false;
  public userLoggedIn: Boolean = false;
  public dropdownToggle: Boolean = false;
  public partnerLoaded = false;
  public bookingState;
  public bookingType = '';
  public selectedLanguage: string = '';
  public availableLaguage: string[] = ['en', 'fr', 'de'];
  public appCopy;
  public copyLoaded: Boolean = false;
  public isErrorScreen: boolean = false;
  public isUpsellScreen: boolean = false;
  public isBookingScreen: boolean = false;
  public isFlyback: boolean = false;
  public classVal: string = 'is-closed';

  constructor(
    private _appStore: Store<AppState>,
    private _router: Router,
    private _loginService: LoginService,
    private _ngZone: NgZone,
    private _sharedService: SharedService,
     private _copyService: CopyService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {
      this._copyService.getStaticCopy()
      this.isBookingScreen = ['flight-finder', 'abc', 'ccd', 'fly-back-details', 'complete'].includes(window.location.pathname.split('/')[1]);
      this._userSubscription = this._appStore.select('userReducer')
        .subscribe((user: any) => {
          this._ngZone.run(() => {
            this.user = user.userDetails;
            this.userLoggedIn = user.userDetails.userLoggedIn;
          });
        });

      this.currentRoute = window.location.pathname.split('/')[1];
      this.handleOverviewSection();

      this._routeSubscription = this._router.events.subscribe(event => {
        // // console.log('routing', event);
        if (event instanceof NavigationStart) {
          this.currentRoute = event.url.split('/')[1];
          this.handleOverviewSection();
        }

        if (event instanceof NavigationEnd) {
          this.isErrorScreen = event.url === '/error-404' || event.url === '/error-500' || event.urlAfterRedirects === '/error-404';
          this.isUpsellScreen = event.url === '/redirectingTo';
          this.isBookingScreen = event.url.includes('abc') || event.url.includes('ccd') || event.url.includes('flight-finder') || event.url.includes('complete') || event.url.includes('fly-back-details');
        }

      });

      this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
        .subscribe((res: any) => {
          this.bookingInit = res.currentBookingLoaded;
          this.copyLoaded = res.copyLoaded;

          if (res.partnerLoaded && this._initLoad) {

            if (this.getState(this._appStore).partnerReducer.partnerName === 'NONE') {
              this.brandingPartner = 'airportr';
            } else {
              this.brandingPartner = this.getState(this._appStore).partnerReducer.partnerName.toLocaleLowerCase();
            }

            this.partnerLoaded = true;
            this._initLoad = false;
          }

          if (this.bookingInit) {
            this.setDataSubscriptions();
          }

          if (res.copyLoaded) {
            this.getCopy();
          }

          this._userLanguageSubscription = this._appStore.select('copyReducer')
          .subscribe((res: any) => {
            this.selectedLanguage = res.language
          })

        });

      this._challengeShopperSubscription = this._sharedService.challengeShopperSubject$.subscribe(challengeActive => {
        this.showOverview = !challengeActive;
      });

    }

    this._flyBackStateSubscription = this._appStore.select('flybackReducer')
    .subscribe((res: any) => {
      this.isFlyback = res.flybackBooking;
      if(this.isFlyback) {
        this.classVal = 'is-open';
      }else {
        this.classVal = 'is-closed';
      }
    });
  }

  setDataSubscriptions() {

    this._bookingStateSubscription = this._appStore.select('bookingReducer')
      .subscribe(bookingState => {
        this.bookingState = bookingState;

        this.bookingType = this.bookingState.bookingDetails.bookingType;
        this.handleOverviewSection();
      });
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'loggedInHeader',
      ['panelHeader']
    );
    // // console.log(panelHeaderCopy)
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }

  // goToLogin() {
  //   this._router.navigate(['login']);
  // }

  // goToRegister() {
  //   this._router.navigate(['register']);
  // }

  // goToMyAccount() {
  // this._appStore.dispatch({ type: 'UPDATE_PARTNER_NAME', payload: { partnerName: 'NONE' } });
  // this._router.routeReuseStrategy.shouldReuseRoute = function(){return false; };
  // const currentUrl = this._router.url + '?';
  // this._router.navigateByUrl(currentUrl)
  //   .then(() => {
  //     this._router.navigated = false;
  //     window.open('my-account/home', '_self');
  //   });
  // }

  logout() {
    this.dropdownToggle = false;
    this._loginService.logout();
  }

  handleOverviewSection() {
    if (
      (this.currentRoute === 'abc' || this.currentRoute === 'ccd' ) && this.bookingType !== 'amend') {
      this.showOverview = true;
    } else {
      this.showOverview = false;
    }
  }

  handleChatClick() {
    zE.activate({ hideOnClose: true });
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {

    if (isPlatformBrowser(this.platformId)) {
      this._bookingInitSubscription.unsubscribe();
      this._challengeShopperSubscription.unsubscribe();
      if (this.bookingInit) {
        this._bookingStateSubscription.unsubscribe();
        this._userSubscription.unsubscribe();
      }
      this._flyBackStateSubscription.unsubscribe();
      if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe() }
    }
  }

}
